import { render, staticRenderFns } from "./BatchLelang.vue?vue&type=template&id=348065c4&"
import script from "./BatchLelang.vue?vue&type=script&lang=js&"
export * from "./BatchLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports